registerComponent("sections/pj-risco-sacado", function (component) {
/**
 * Risco Sacado — sem comportamento próprio.
 *
 * A entrada escalonada observa `.card`, `.produtos__app` e `.produtos__midia`
 * (ver `_produtos.js`); esta seção não tem nenhum dos três no bloco de cima, e
 * os passos entram com a seção. Se o cliente pedir que o mockup e os passos
 * entrem escalonados, o caminho é acrescentá-los ao seletor de lá — não abrir
 * um observador aqui.
 */

});
